import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "hr-tile" }
const _hoisted_2 = { class: "breadcrumbs" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = {
  key: 0,
  class: "breadcrumb-item"
}
const _hoisted_5 = {
  key: 1,
  class: "breadcrumb-item"
}
const _hoisted_6 = {
  key: 2,
  class: "breadcrumb-item"
}
const _hoisted_7 = { class: "columns" }
const _hoisted_8 = { class: "column is-two-thirds" }
const _hoisted_9 = {
  key: 0,
  class: "hr-tile greeble-tr"
}
const _hoisted_10 = {
  key: 0,
  class: "news-pagination"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 1,
  class: "hr-tile greeble-tr"
}
const _hoisted_14 = { class: "title is-3" }
const _hoisted_15 = { class: "column is-one-third" }
const _hoisted_16 = {
  key: 0,
  class: "hr-tile admin-panel"
}
const _hoisted_17 = { class: "admin-options" }
const _hoisted_18 = {
  key: 1,
  class: "hr-tile"
}
const _hoisted_19 = {
  key: 2,
  class: "hr-tile"
}
const _hoisted_20 = { class: "news-options" }
const _hoisted_21 = { class: "game-selector" }
const _hoisted_22 = { class: "game-options" }
const _hoisted_23 = ["checked", "onChange"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NewsFeed = _resolveComponent("NewsFeed")!
  const _component_NewsArticleComponent = _resolveComponent("NewsArticleComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createVNode(_component_router_link, { to: '/' }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("Home")
            ])),
            _: 1
          })
        ]),
        (!_ctx.currentArticle)
          ? (_openBlock(), _createElementBlock("li", _hoisted_4, _cache[5] || (_cache[5] = [
              _createElementVNode("span", null, "News", -1)
            ])))
          : (_openBlock(), _createElementBlock("li", _hoisted_5, [
              _createVNode(_component_router_link, { to: '/news' }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("News")
                ])),
                _: 1
              })
            ])),
        (_ctx.currentArticle)
          ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(_ctx.currentArticle.Title), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (!_ctx.currentArticle)
          ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
              _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "title is-4" }, " Latest Articles ", -1)),
              _createVNode(_component_NewsFeed, {
                thumb: true,
                gameNames: _ctx.gameNames,
                newsFeed: _ctx.filteredNewsFeed.slice((_ctx.page-1)*10, _ctx.page*10)
              }, null, 8, ["gameNames", "newsFeed"]),
              (_ctx.filteredNewsFeed.length > 10)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("button", {
                      class: "button is-primary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.page--)),
                      disabled: _ctx.page === 1
                    }, "Previous", 8, _hoisted_11),
                    _createElementVNode("span", null, "Page " + _toDisplayString(_ctx.page) + " of " + _toDisplayString(Math.ceil(_ctx.filteredNewsFeed.length / 10)), 1),
                    _createElementVNode("button", {
                      class: "button is-primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.page++)),
                      disabled: _ctx.page === Math.ceil(_ctx.filteredNewsFeed.length / 10)
                    }, "Next", 8, _hoisted_12)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("section", _hoisted_13, [
              _createElementVNode("h4", _hoisted_14, _toDisplayString(_ctx.currentArticle.Title), 1),
              _createVNode(_component_NewsArticleComponent, {
                gameNames: _ctx.gameNames,
                article: _ctx.currentArticle
              }, null, 8, ["gameNames", "article"])
            ]))
      ]),
      _createElementVNode("div", _hoisted_15, [
        (_ctx.hasAdminClaim)
          ? (_openBlock(), _createElementBlock("section", _hoisted_16, [
              _cache[11] || (_cache[11] = _createElementVNode("h4", { class: "title is-4" }, " Admin Options ", -1)),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_router_link, {
                  class: "button is-primary",
                  to: '/admin/news/create'
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode("New Article")
                  ])),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  class: "button is-secondary",
                  to: "/admin/news"
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode("Manage Articles")
                  ])),
                  _: 1
                }),
                (_ctx.currentArticle)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      class: "button is-secondary",
                      to: '/admin/news/' + _ctx.currentArticle.UrlStub
                    }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode("Edit Article")
                      ])),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.allNews)
          ? (_openBlock(), _createElementBlock("section", _hoisted_18, [
              _cache[12] || (_cache[12] = _createElementVNode("h4", { class: "title is-4" }, " Featured Articles ", -1)),
              _createVNode(_component_NewsFeed, {
                thumb: false,
                gameNames: _ctx.gameNames,
                newsFeed: _ctx.allNews.filter(i => i.Featured)
              }, null, 8, ["gameNames", "newsFeed"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.currentArticle)
          ? (_openBlock(), _createElementBlock("section", _hoisted_19, [
              _cache[14] || (_cache[14] = _createElementVNode("h4", { class: "title is-4" }, " Filter Articles ", -1)),
              _createElementVNode("div", _hoisted_20, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "input",
                  style: {"flex-grow":"1"},
                  placeholder: "Search",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
                  onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.applySearch()))
                }, null, 544), [
                  [_vModelText, _ctx.search]
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("label", null, "Filter News for Specific Games", -1)),
                _createElementVNode("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games, (game) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        checked: _ctx.filteredGames.get(game.Id),
                        onChange: ($event: any) => (_ctx.filterGame(game.Id))
                      }, null, 40, _hoisted_23),
                      _createElementVNode("span", null, _toDisplayString(game.Name), 1)
                    ]))
                  }), 256))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}